module.exports = __webpack_public_path__ + "static/media/info-channel.d9297f32.svg";